import { TEDParseNumberMode } from '../FormatterTypes';
import { TEDCustomNumberDisplayer } from './TEDCustomNumberDisplayer';

class TEDDisplayDegrees extends TEDCustomNumberDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDDisplayDegrees;

  public mode() {
    return TEDParseNumberMode.pnmDegrees;
  }
}

export { TEDDisplayDegrees };
